import React from "react";
import { Paper, Box, Typography, Divider, Grid, Chip } from "@mui/material";

const PreferenceDetailsSection = ({ profile }) => {
  if (!profile?.meta) return null;
  const meta = profile.meta;

  const renderChips = (items) => {
    if (!items) return "N/A";
    if (Array.isArray(items)) {
      return (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {items.map((item, i) => (
            <Chip
              key={i}
              label={item.name || item}
              color="primary"
              variant="outlined"
            />
          ))}
        </Box>
      );
    }
    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {items
          .split(",")
          .map((i) => i.trim())
          .filter(Boolean)
          .map((item, i) => (
            <Chip key={i} label={item} color="primary" variant="outlined" />
          ))}
      </Box>
    );
  };

  return (
    <Paper
      elevation={4}
      sx={{
        p: 4,
        mb: 3,
        borderRadius: 3,
      }}
    >
      {/* Section Title */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          color: "primary.main",
          mb: 2,
        }}
      >
        Preferences
      </Typography>
      <Divider sx={{ mb: 3 }} />

      {/* RELATIONSHIP PREFERENCES */}
      <Box sx={{ mb: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography px={0} py={1} m={0}>
              <strong>Marry Someone With Kids:</strong>{" "}
              {meta.marrySomeoneWithKids || "N/A"}
            </Typography>
            <Typography px={0} py={1} m={0}>
              <strong>Move Abroad:</strong> {meta.moveAbroad || "N/A"}
            </Typography>
            <Typography px={0} py={1} m={0}>
              <strong>Move for Work:</strong> {meta.moveForWork || "N/A"}
            </Typography>
            <Typography px={0} py={1} m={0}>
              <strong>Marriage Approach:</strong>{" "}
              {meta.marriageApproach || "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography px={0} py={1} m={0}>
              <strong>Preferred Age Range:</strong>{" "}
              {meta.preferredAgeRange || "N/A"}
            </Typography>
            <Typography px={0} py={1} m={0}>
              <strong>Preferred Ethnicity:</strong>{" "}
              {meta.preferredEthnicity || "N/A"}
            </Typography>
            <Typography px={0} py={1} m={0}>
              <strong>Preferred Nationality:</strong>{" "}
              {meta.preferredNationality || "N/A"}
            </Typography>
            <Typography px={0} py={1} m={0}>
              <strong>Preferred Sect:</strong> {meta.preferredSect || "N/A"}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* LIFESTYLE & PERSONAL VALUES */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", mb: 1, color: "primary.main" }}
        >
          Lifestyle & Personal Values
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography px={0} py={0} m={0}>
              <strong>Financial Responsibilities:</strong>{" "}
            </Typography>
            <Typography
              sx={{
                whiteSpace: "pre-line",
                color: "text.primary",
                mb: 2,
              }}
              px={0}
              py={1}
              m={0}
            >
              {meta.financialResponsibilities || "N/A"}
            </Typography>
            <Typography px={0} py={0} m={0}>
              <strong>Spouse Career Expectations:</strong>{" "}
            </Typography>
            <Typography
              sx={{
                whiteSpace: "pre-line",
                color: "text.primary",
                mb: 2,
              }}
              px={0}
              py={1}
              m={0}
            >
              {meta.spouseCareerExpectations || "N/A"}
            </Typography>
            <Typography px={0} py={0} m={0}>
              <strong>Partner Education Preference:</strong>{" "}
            </Typography>
            <Typography
              sx={{
                whiteSpace: "pre-line",
                color: "text.primary",
                mb: 2,
              }}
              px={0}
              py={1}
              m={0}
            >
              {meta.partnerEducationPref || "N/A"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography px={0} py={0} m={0}>
              <strong>Partner Expectations:</strong>
            </Typography>
            <Typography
              sx={{
                whiteSpace: "pre-line",
                color: "text.primary",
                mb: 2,
              }}
              px={0}
              py={1}
              m={0}
            >
              {meta.partnerExpectations || "N/A"}
            </Typography>
            <Typography px={0} py={0} m={0}>
              <strong>Important Qualities:</strong>
            </Typography>
            <Typography
              sx={{
                whiteSpace: "pre-line",
                color: "text.primary",
              }}
              px={0}
              py={1}
              m={0}
            >
              {meta.importantQualities || "N/A"}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* FINAL */}
      <Box>
        <Divider sx={{ mb: 2 }} />
        {/* FINAL THOUGHTS */}
        {meta.finalThoughts && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 800 }}  px={0} py={0} m={0}>
              Final Thoughts:
            </Typography>
            <Typography
              variant="body1"
              sx={{
                whiteSpace: "pre-line",
                color: "text.primary",
                mt: 1,
              }}
               px={0} py={1} m={0}
            >
              {meta.finalThoughts}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default PreferenceDetailsSection;
